/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: CheckBoxControlInput.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/15 @ 1510
 * ---
 * Description:
 */

import { observer }               from 'mobx-react';
import { ChildControlFieldProps } from './ShapeControlView';
import { ShapeControlWrapper }    from './ShapeControlWrapper';
import { useEffect, useState }    from 'react';
import { Checkbox }               from '@blueprintjs/core';

export const CheckBoxControlInput = observer((props: ChildControlFieldProps<boolean>) => {
  const [value, setValue] = useState(false);

  useEffect(() => {
    setValue(props.observableValue);
  }, [props.label, props.observableValue]);

  return (
    <ShapeControlWrapper label={ props.label }>
      <Checkbox checked={ value } label={ props.labelInfo }
                onChange={ (event) => {
                  const value = (event.target as any).checked;
                  setValue(value);
                  props.setter(value);
                } }/>
    </ShapeControlWrapper>
  );
});